import { AutogenModelEdiNotify, AutogenRowEdiNotify } from "./autogen/AutogenModelEdiNotify";

export class ModelEdiNotify extends AutogenModelEdiNotify<RowEdiNotify> {
	constructor() {
		super(RowEdiNotify);
	}
}

export class RowEdiNotify extends AutogenRowEdiNotify {
}